(function () {
  const cache = new Map();

  function applyForRef(ref, units, progress) {
    const pct = progress.toFixed(1) + '%';
    const pctClean = Math.trunc(progress) + '%';
    const refSel = CSS.escape(ref);

    document.querySelectorAll(`.stock-progress[data-ref="${refSel}"]`).forEach((el) => {
      const uv = el.querySelector('.units-value');
      if (uv) uv.textContent = units;
      const pv = el.querySelector('.progress-value');
      if (pv) pv.textContent = pctClean;
      el.querySelector('.stock-progress__progress-fill')?.style.setProperty('--progress-fill', pct);
      el.dataset.stockReady = 'true';
    });

    document.querySelectorAll(`.stock-units-sync[data-ref="${refSel}"]`).forEach((el) => {
      el.dataset.stockReady = 'true';
    });

    document.querySelectorAll(`[data-stock-ref="${refSel}"] .units-value`).forEach((uv) => {
      uv.textContent = units;
    });

    document.querySelectorAll(`[data-stock-ref="${refSel}"] .progress-value`).forEach((pv) => {
      pv.textContent = pctClean;
    });
  }

  function compute(root) {
    const ref = root.dataset.ref || `page_${location.pathname}`;
    const min = parseInt(root.dataset.minUnits, 10) || 10;
    const max = parseInt(root.dataset.maxUnits, 10) || 1000;
    const minPct = parseFloat(root.dataset.progressMin) || 10;
    const initPct = parseFloat(root.dataset.progressInitial) || 75;
    const stored = JSON.parse(localStorage.getItem(`stock_${ref}`) || 'null');
    let progress;
    let units;

    if (!stored) {
      progress = Math.min(100, Math.max(minPct, initPct + (Math.random() * 20 - 10)));
      units = Math.round(min + (max - min) * progress / 100);
    } else {
      const drop = Math.random() * 4 + 1;
      progress = Math.max(minPct, stored.progress - drop);
      units = Math.max(min, stored.units - Math.round((max - min) * drop / 100));
    }

    localStorage.setItem(`stock_${ref}`, JSON.stringify({ units, progress }));
    return { ref, units, progress };
  }

  window.initStockEl = function (el) {
    if (!el || el.dataset.stockReady) return;
    if (!el.matches('.stock-progress, .stock-units-sync')) return;

    const ref = el.dataset.ref || `page_${location.pathname}`;

    if (cache.has(ref)) {
      const { units, progress } = cache.get(ref);
      applyForRef(ref, units, progress);
      return;
    }

    const { units, progress } = compute(el);
    cache.set(ref, { units, progress });
    applyForRef(ref, units, progress);
  };

  window.initStockAll = function () {
    document.querySelectorAll('.stock-progress:not([data-stock-ready]), .stock-units-sync:not([data-stock-ready])').forEach(window.initStockEl);
  };
})();
